module.exports = __webpack_public_path__ + "media/23.67fce624.mp3";